import * as Common from '@/agiles/common';

export class GroupMember extends Common.ObjectBase{
    constructor(userId:string = null, groupId:string=null){
        super('GroupMember');
        this.userId = userId;
        this.groupId = groupId;
    }    
        public groupId: string;
        public userId: string;        
        //public user: Common.User;
        //public group : Common.Group;
}

export class GroupMemberQuery extends Common.LoadQuery {
  constructor() {
    super('GroupMemberQuery', GroupMember);
    this.sort = 'groupId';
  }
  public groupId: string;
  public userId: string;         
}